const HISTORY_KEY = "pliego-reading-history-v1";
const OFFLINE_KEY = "pliego-offline-materials-v1";
const CACHE_NAME = "pliego-documents-v1";

function read(key) {
  try { return JSON.parse(localStorage.getItem(key) || "[]"); }
  catch { return []; }
}

function write(key, value) {
  localStorage.setItem(key, JSON.stringify(value));
  window.dispatchEvent(new CustomEvent("pliego-library-change"));
}

export function readingHistory() {
  return read(HISTORY_KEY).sort((a, b) => String(b.updatedAt).localeCompare(String(a.updatedAt)));
}

export function recordReading(entry) {
  if (!entry?.materialID) return;
  const next = [entry, ...readingHistory().filter(item => item.materialID !== entry.materialID)].slice(0, 30);
  write(HISTORY_KEY, next);
}

export function clearReadingHistory() {
  write(HISTORY_KEY, []);
}

export function offlineMaterials() {
  return read(OFFLINE_KEY).sort((a, b) => String(b.downloadedAt).localeCompare(String(a.downloadedAt)));
}

export function isMaterialOffline(materialID) {
  return offlineMaterials().some(item => item.id === materialID);
}

export async function saveMaterialOffline(material) {
  if (!("caches" in window)) throw new Error("Este navegador no permite guardar documentos sin conexión.");
  const response = await fetch(material.fileURL);
  if (!response.ok) throw new Error("No se ha podido descargar el documento.");
  const cache = await caches.open(CACHE_NAME);
  await cache.put(material.fileURL, response.clone());
  const compact = {
    ...material,
    downloadedAt: new Date().toISOString()
  };
  write(OFFLINE_KEY, [compact, ...offlineMaterials().filter(item => item.id !== material.id)]);
}

export async function removeMaterialOffline(material) {
  if ("caches" in window) {
    const cache = await caches.open(CACHE_NAME);
    await cache.delete(material.fileURL);
  }
  write(OFFLINE_KEY, offlineMaterials().filter(item => item.id !== material.id));
}

export async function resolveDocumentSource(url) {
  if (!("caches" in window)) return { url, revoke: null };
  const cache = await caches.open(CACHE_NAME);
  const response = await cache.match(url);
  if (!response) return { url, revoke: null };
  const objectURL = URL.createObjectURL(await response.blob());
  return { url: objectURL, revoke: () => URL.revokeObjectURL(objectURL) };
}
